import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import ShopInner from "../Components/Shop/OurAcc";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function Shop() {
  return (
    <>
      <Helmet>
        <title>Our Accessories | Howly Wizard</title>
      </Helmet>
      <HeaderOne />
      <ShopInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Shop;
